// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre
let service = require('@/../config/serviceList')
export default {
  // 获取对接平台列表
  getCompanyInfos(params) {
    return http.requestPost(apiPre + service.res + '/res/cecCompanyInfo/getList', params)
  },
  // 平台信息入库
  insertCec(params) {
    return http.requestPost(apiPre + service.res + '/res/cecCompanyInfo/insert', params)
  },
//获取单条对接平台信息
  getDtoById(params) {
    return http.requestPost(apiPre + service.res + '/res/cecCompanyInfo/getCompanyInfo/'+params, {})
  },
 //删除但对接平台信息
  deleteCecById(params) {
    return http.requestPost(apiPre + service.res + '/res/cecCompanyInfo/deleteById/' + params, '')
  },
  //更新但对接平台信息
  update(params) {
    return http.requestPost(apiPre + service.res + '/res/cecCompanyInfo/update/', params)
  },
  //更新但对接平台信息
  availableSwitch(params) {
    return http.requestPost(apiPre + service.res + '/res/cecCompanyInfo/availableSwitch/', params)
  },
}



// WEBPACK FOOTER //
// ./src/module/interactionCenter/api/cec.js